module.exports = {
    language: {
        name: 'English'
    },
    user: {
        login:'登录',
        register:'注册',
        loginUsername:'请输入邮箱/手机号',
    },
    mainPage:{
        UWSEn:'英国西苏格兰大学（英文官网）',
        UWSCn:'英国西苏格兰大学（中文官网）',
        THU:'无锡太湖学院',
        schoolAddress:'学院地址：江苏省无锡市钱荣路68号',
        telephone:'招生咨询电话：0510-85509888 | 85522008 | 8550399',
        phone:'电话：0510-85502763',
        fax:'传真：0510-85502663',
        tencent:'公众号',
    }
}


// WEBPACK FOOTER //
// ./src/components/work/language/zh/zh.js